import { useCallback } from "react";
import useWeb3 from "../useWeb3";
// import { useWeb3React } from "@web3-react/core";
import { Contract as MulticallContract, Provider as MulticallProvider } from 'ethers-multicall';
import TradePoolAbi from '../../utils/TradePoolAbi.json'
import { useRecoilValue } from "recoil";
import { userSmartAccount } from "../../components/RecoilAtom";
import { useEoaAccount } from "../useEoaAccount";

const useEscrowOrderSharesHook = () => {
    const {  provider } = useEoaAccount();
    const web3 = useWeb3();
    const smartAccount = useRecoilValue(userSmartAccount)

    const getEscrowOrderSharesHook = useCallback(
        async (address, optionsIdsInPool) => {
            try {
                const ethcallProvider = new MulticallProvider(
                    provider || web3.currentProvider || web3.provider || web3.eth.currentProvider
                );
                await ethcallProvider.init();
                const multicallContract = new MulticallContract(address, TradePoolAbi);
                const calls = optionsIdsInPool.map(choiceIndex =>
                    multicallContract.userVotesInEscrow(choiceIndex, smartAccount)
                );
                const sharesInOrderBigNumbers = await ethcallProvider.all(calls);
                return sharesInOrderBigNumbers;
            } catch (error) {
                console.error('Error fetching escrow shares:', error);
                throw error;
            }
        },
        [web3, smartAccount, provider]
    );

    return { getEscrowOrderSharesHook };
};

export default useEscrowOrderSharesHook;